<!-- title -->
<app-modal-title [title]="'common.smsPreview'|translate" [isShowClose]="true" (isCloseModal)="onClose()">
  <span header-content class="tw-text-base tw-font-normal">
    * <span [innerHTML]="'messages.chooseItem' | translate"></span>
  </span>
</app-modal-title>


<div mat-dialog-content class="dialog-content">
  <app-sms-template-group [isModalMode]="true" [isShowAuditBtn]="false" (selectedSmsTemplate)="onSelect($event)">
  </app-sms-template-group>
</div>